<template>
    <div class="content content-aligned">
        <h1>Lær at lave et skydespil</h1>
        <p>Et spil hvor man skal skyde efter ting, objekter eller endda en
            modspiller. </p>
        <p>Kan laves så man spiller 2 mod hinanden. </p>

        <div
          style="max-width: 400px; padding: 18px 18px; margin: 0 auto; font-weight:bold; color: white; border-radius: 12px; background-color: #ff00f9">
  
          <h3 style="padding:0;margin:0;">Vigtigt! Spillet lagger nogle gange sindssygt på Chromebooks, kig evt. på dette projekt i stedet:
            <a href="https://scratch.mit.edu/projects/329431807/" target="_blank"> Click to shoot</a>
   
</h3></div>
        

        <div class="content--centered">
            <EmbedYoutube class="video-tut-embed" id="ObVGRWfuxEg" title="Step 1" />
            <EmbedYoutube class="video-tut-embed" id="zcOZsEjWIOM" title="Step 2" />
            <EmbedYoutube class="video-tut-embed" id="6E3MvxSBnoM" title="Step 3" />
        </div>
    </div>
</template>

<script>
import EmbedYoutube from "@/components/YoutubeEmbed";

export default {
    name: "VideoTutSkyde",
    components: {
        EmbedYoutube
    },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/pages/video-tutorials/video-tut-skyde.vue